module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Личный кабинет")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "6"
    }
  }, [_c('column', {
    attrs: {
      "size": "9"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('p', [_vm._v("Добро пожаловать в личный кабинет абонента! Введите регистрационные данные в форму ниже.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("данные для авторизации можно найти в договоре, для получения\n          дополнительной информации обратитесь по телефону "), _c('a', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "href": "tel:84957739215"
    }
  }, [_vm._v("8 (495) 773-92-15")])])])], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "4"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "name": "login",
      "action": "/login",
      "method": "post"
    },
    on: {
      "submit": _vm.submitForm
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login),
      expression: "login"
    }],
    attrs: {
      "placeholder": "Логин"
    },
    domProps: {
      "value": (_vm.login)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "Пароль"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: [_vm.errors.submit ? 'invalid' : ''],
    attrs: {
      "type": "submit",
      "disabled": !(_vm.login && _vm.password)
    }
  }, [_vm._v("\n              Войти\n            ")]), _vm._v(" "), (_vm.errors.submit) ? _c('label', [_vm._v(_vm._s(_vm.errors.submit))]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dbc6d6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Profile.vue
// module id = 129
// module chunks = 0